import { useState, useEffect } from 'react'
import { getClusterById } from '@/services/cluster'

export const useClusterById = (id?: string) => {
  const [item, setItem] = useState<any>(null)
  const [associatedModalities, setAssociatedModalities] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!id) {
      setLoading(false)
      return
    }

    const fetchCluster = async () => {
      try {
        setLoading(true)
        setError(null)
        const response = await getClusterById(id)
        setItem(response.cluster || null)
        setAssociatedModalities(response.associatedModalities || [])
      } catch (err: any) {
        setError(err.message || 'Failed to fetch cluster')
      } finally {
        setLoading(false)
      }
    }

    fetchCluster()
  }, [id])

  return { item, associatedModalities, loading, error }
}
